// VolumeSurgeTable.jsx
import React, { useEffect, useState } from "react";
import { Sparklines, SparklinesLine } from "react-sparklines";
import {fetchTable} from "../../api";

const VolumeSurgeTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchTable("intraday_vol_surge",'n50')
      // .then((res) => res.json())
      .then((json) => setData(json));
    console.log('VOL SURGE DATA ->',data)
  }, []);

  return (
    <div className="p-4">
      <h4 className="text-l font-bold mb-8">📊 Volume Surge Table</h4>
      <table className="w-full border-collapse">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 text-left">Symbol</th>
            <th className="p-2 text-right">Intraday Vol (Cr)</th>
            <th className="p-2 text-right">Avg Vol (Cr)</th>
            <th className="p-2 text-right">Surge Ratio</th>
            <th className="p-2 text-center">Price Sparkline</th>
            <th className="p-2 text-center">Volume Sparkline</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} className="border-b">
              <td className="p-2">
                <a href={`/stock/${row.symbol}`}>
                {row.symbol}
                </a>
              </td>
              <td className="p-2 text-right">
                {(row.intraday_volume / 1e7).toFixed(2)}
              </td>
              <td className="p-2 text-right">
                {(row.avg_volume / 1e7).toFixed(2)}
              </td>
              <td className="p-2 text-right"  style={{ color: "maroon" }}>
                {row.surge_ratio}x
              </td>
              <td className="p-2">
                <Sparklines data={row.price_series} svgWidth={50} svgHeight={20}>
                  <SparklinesLine color="blue" />
                </Sparklines>
              </td>
              <td className="p-2">
                <Sparklines data={row.volume_series} svgWidth={50} svgHeight={20}>
                  <SparklinesLine color="orange" />
                </Sparklines>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VolumeSurgeTable;

